/**
 * Mobile product description: marks short copy (no read-more) via .is-short
 * Expand/collapse uses checkbox + label in markup (no click handler needed).
 */
(function () {
  const MOBILE_MQ = "(max-width: 768px)";
  const COLLAPSED_LINES = 2;

  function getMeasureTarget(content) {
    return content?.querySelector("p") || content;
  }

  function getLineHeight(target) {
    if (!target) return 20;
    const lineHeight = parseFloat(getComputedStyle(target).lineHeight);
    return !Number.isNaN(lineHeight) && lineHeight > 0 ? lineHeight : 20;
  }

  function getMeasureWidth(target, content, host) {
    return (
      target.getBoundingClientRect().width ||
      content.getBoundingClientRect().width ||
      host.getBoundingClientRect().width ||
      0
    );
  }

  function needsCollapse(host) {
    const content = host.querySelector(".wt-product__text-block");
    const target = getMeasureTarget(content);
    const text = target?.textContent?.replace(/\s+/g, " ").trim();
    if (!target || !text) return false;

    const width = getMeasureWidth(target, content, host);
    if (!width) return true;

    const lineHeight = getLineHeight(target);
    const collapsedMax = lineHeight * COLLAPSED_LINES;

    const clone = target.cloneNode(true);
    clone.style.cssText = [
      "position:absolute",
      "visibility:hidden",
      "pointer-events:none",
      "left:-9999px",
      "top:0",
      `width:${width}px`,
      "height:auto",
      "max-height:none",
      "display:block",
      "overflow:visible",
      "margin:0",
    ].join(";");

    document.body.appendChild(clone);
    const fullHeight = clone.offsetHeight;
    clone.remove();

    return fullHeight > collapsedMax + 1;
  }

  function updateHost(host) {
    const mq = window.matchMedia(MOBILE_MQ);
    const checkbox = host.querySelector(".wd-product-description__checkbox");
    const lineHeight = getLineHeight(getMeasureTarget(host.querySelector(".wt-product__text-block")));

    host.style.setProperty("--wd-desc-line-height", `${lineHeight}px`);

    if (!mq.matches) {
      host.classList.remove("is-short", "is-overflowing");
      if (checkbox) checkbox.checked = false;
      return;
    }

    const overflow = needsCollapse(host);
    host.classList.toggle("is-overflowing", overflow);
    host.classList.toggle("is-short", !overflow);

    if (!overflow && checkbox) {
      checkbox.checked = false;
    }
  }

  function updateAll() {
    document.querySelectorAll(".wd-product-description").forEach(updateHost);
  }

  let frame;
  function scheduleUpdate() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(updateAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  window.addEventListener("resize", scheduleUpdate, { passive: true });
  window.addEventListener("load", scheduleUpdate, { passive: true });

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleUpdate);
  }

  document.querySelectorAll(".wd-product-description .wt-product__text-block").forEach((el) => {
    new ResizeObserver(scheduleUpdate).observe(el);
  });
})();
